module.exports = __webpack_public_path__ + "static/media/laptop-clone.72e041e4.svg";